import { usePage } from '@inertiajs/react'
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar'
import { LayoutDashboard, Building2, Wallet } from 'lucide-react'
import bewaveLogo from '@/assets/logo-white.png'

const menuItems = [
  { title: 'Dashboard', url: '/platform/dashboard', icon: LayoutDashboard },
  { title: 'Escolas', url: '/platform/schools', icon: Building2 },
  { title: 'Repasses', url: '/platform/payouts', icon: Wallet },
]

export function PlatformSidebar() {
  const page = usePage()
  const currentPath = page.url.split('?')[0]

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader className="border-b border-sidebar-border p-5 group-data-[collapsible=icon]:hidden flex items-center justify-center">
        <img src={bewaveLogo} alt="BeeWave" className="h-10" />
      </SidebarHeader>

      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel className="group-data-[collapsible=icon]:hidden">
            Plataforma
          </SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {menuItems.map((item) => {
                const isActive =
                  currentPath === item.url ||
                  currentPath.startsWith(item.url + '/')

                return (
                  <SidebarMenuItem
                    key={item.title}
                    className={isActive ? 'border-l-4 border-primary' : ''}
                  >
                    <SidebarMenuButton
                      asChild
                      isActive={isActive}
                      className={
                        isActive
                          ? 'bg-primary text-primary-foreground font-semibold hover:bg-primary hover:text-primary-foreground'
                          : ''
                      }
                    >
                      <a href={item.url}>
                        <item.icon className="h-4 w-4" />
                        <span>{item.title}</span>
                      </a>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                )
              })}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  )
}
